import React from 'react';

/**
 * Official Google Analytics mark supplied for Mora's connection directory.
 * Keep it as a provider-native asset: its amber bar geometry distinguishes
 * Analytics from the Google account and Google Ads marks used elsewhere.
 */
export const GoogleAnalyticsIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({
  className,
  ...props
}) => (
  <img
    src="/icons/google-analytics-icon.svg"
    alt=""
    className={className}
    {...(props as unknown as React.ImgHTMLAttributes<HTMLImageElement>)}
  />
);
